<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-forum-category') }}
            <div class="card-header-actions">
              <router-link :to="'/office/forum/post/' + postId" class="card-header-action btn-setting">
                <buttons button-type="back" />
              </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveData">
            <b-row>
              <b-col sm="12">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">{{ $t('str.message') }}</th>
                      <td>
                        <textarea id="message" name="message" rows="3"
                          :class="{ 'form-control': true, 'is-invalid': errors.has('message') }"
                          v-validate="{ required: true }" v-model="addData.message"></textarea>
                        <span class="invalid-feedback">{{ errors.first('message') }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="attachments.length">
              <b-col sm="12">
                <table class="table">
                  <tbody>
                    <tr>
                      <th scope="col">{{ $t('str.attachments') }}</th>
                      <th scope="col">{{ $t('str.action') }}</th>
                    </tr>
                    <tr v-for="(val, i) in attachments" :key="i">
                      <td>
                        <img v-if="val.type === 'image'" :src="val.filepath" style="height:100px; width:auto;"
                          v-b-modal.img_modal @click="openImgModal(val.filepath)" />
                        <video v-if="val.type === 'video'" controls style="height:300px; width:auto;">
                          <source :src="val.filepath">
                          Your browser does not support the video tag.
                        </video>
                        <a v-if="val.type === 'doc'" :href="val.filepath" target="_blank" download>{{ $t('str.download')
                        }}</a>
                      </td>
                      <td>
                        <buttons v-if="!val.deleted_at" button-type="delete"
                          @click="confirmDeleteCommentAttachment(val.id)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit" />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <confirm-modal :item="confirmDeleteCommentAttachmentId" @confirm="deleteCommentAttachment" @cancel="cancelDelete">
    </confirm-modal>
  </div>
</template>

<script>
import axios from 'axios'

import Buttons from '@/views/component/Buttons'
import ConfirmModal from '@/views/component/ConfirmModal'
import ImgModal from '@/views/component/ImgModal'

export default {
  components: {
    'buttons': Buttons,
    'confirm-modal': ConfirmModal,
    'img-modal': ImgModal
  },
  data() {
    return {
      postId: this.$route.params.post_id,
      id: this.$route.params.id,
      addData: {
        message: '',
      },
      attachments: [],

      imgModal: false,
      imgModalUrl: '',
      confirmModalCommentAttachment: false,
      confirmDeleteCommentAttachmentId: '',
    }
  },
  methods: {
    async getData() {
      this.$auth.checkSession()
      let dataId = this.id

      if (dataId > 0) {
        try {
          let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Forum/PostComment/${dataId}`, {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

          this.addData.message = getData.data.data.message.replace(/(<([^>]+)>)/gi, '')
          this.attachments = getData.data.data.attachments
        } catch (e) {
          console.log('err', e.response)
          if (e.response) {
            this.$router.push('/pages/404')
          }
        }
      }
    },
    async saveData() {
      this.$auth.checkSession()
      if (this.$validator.validateAll()) {
        if (this.id > 0) {
          let method = 'patch'
          let url = `${this.$helper.envi.VUE_APP_API_URL}/Forum/PostComment/${this.id}`

          try {
            var result = await axios[method](url, this.addData, {
              headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
            })

            this.$toast.success(result.data.meta.message, '', {
              position: 'topCenter'
            })
          } catch (e) {
            if (Array.isArray(e.response.data.meta.error)) {
              e.response.data.meta.error.forEach((err) => {
                this.$toast.error(err.msg, e.response.data.meta.message, {
                  position: 'topCenter'
                })
              })
            } else if (typeof e.response.data.meta.error === 'string') {
              this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
                position: 'topCenter'
              })
            }
          }
        }
      }
    },

    async deleteCommentAttachment(id) {
      this.$auth.checkSession()
      try {
        let result = await axios.delete(`${this.$helper.envi.VUE_APP_API_URL}/Forum/PostCommentAttachment/${id}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getData()
        this.confirmModalPostAttachment = false
      } catch (e) {
        console.log(e.response)
      }
    },

    openImgModal(url) {
      this.imgModal = true
      this.imgModalUrl = url
    },
    confirmDeleteCommentAttachment(id) {
      this.$auth.checkSession()
      this.confirmModalCommentAttachment = true
      this.confirmDeleteCommentAttachmentId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmModalCommentAttachment = false
    }
  },
  created() {
    this.getData()
  },
}
</script>